import { animated, easings, useSprings } from '@react-spring/three';
import { ReactNode } from 'react';

type Props = {
  steps: ReactNode[];
  currentIndex: number;
  distance?: number;
};

export const Steps = ({ steps, currentIndex, distance = 2 }: Props) => {
  const [springs] = useSprings(
    steps.length,
    index => {
      return {
        positionX: (index - currentIndex) * distance,
        config: {
          duration: 500,
          easing: easings.easeInOutSine,
          precision: 0.0001,
        },
      };
    },
    [steps.length, currentIndex]
  );

  return (
    <>
      {steps.map((step, index) => (
        <animated.group
          // eslint-disable-next-line react/no-array-index-key
          key={index}
          position-x={springs[index]!.positionX}
          visible={Math.abs(index - currentIndex) <= 1}
        >
          {step}
        </animated.group>
      ))}
    </>
  );
};

export default Steps;
